import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { HttpService } from './http.service';

export interface VendorAckState {
  code: string;
  acked: boolean;
  ackDate?: string;
  manualOverride?: boolean;
}

export interface StuckProgramRow {
  program: string;
  submissionCode: string;
  unit: string;
  campusCode: string;
  status: string;
  modifiedDate: string;
  ageDays: number;
  submitter: { name: string; email: string } | null;
  vendors: VendorAckState[] | null;
  vendorsError?: string;
}

export interface ManualAckResult {
  status: string;
  ackReferenceId?: string | null;
}

@Injectable()
export class StuckProgramsService {
  constructor(private http: HttpService) {}

  list(): Promise<StuckProgramRow[]> {
    return this.http
      .get(`${environment.SERVER_URL}/admin/stuck-programs`)
      .then((data) => data as unknown as StuckProgramRow[]);
  }

  fakeAck(program: string, vendor: string): Promise<ManualAckResult> {
    return this.http
      .post(
        `${environment.SERVER_URL}/admin/stuck-programs/${encodeURIComponent(program)}/fake-ack/${encodeURIComponent(vendor)}`,
        {},
      )
      .then((data) => data as unknown as ManualAckResult);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/service/stuck-programs.service.ts